import classNames from 'classnames';
import type { HTMLAttributes } from 'react';
import { APP_NAME, getLocale } from '@hub/libs/constants';
import type { ShapeDescriptor } from '@hub/bearing-hub/common/shapes/shapes';
import type { IbhShape } from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { SUPPORTED_IGLIDE_IBH_LOCALES } from '@hub/libs/bearing-hub.helper';
import { useRouter } from 'next/router';

interface ShapeCardProps extends HTMLAttributes<HTMLDivElement> {
  shape: ShapeDescriptor;
  selectedShape: IbhShape;
  searchParams: string;
  clientReady: boolean;
}

export const ShapeCard = ({ shape, selectedShape, searchParams, clientReady }: ShapeCardProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);
  const router = useRouter();
  const locale = getLocale(router);

  const isSelected = selectedShape === shape.shapeKey;

  return (
    <div className="flex flex-col items-center w-[125px]">
      <Link
        prefetch={false}
        href={`/${SUPPORTED_IGLIDE_IBH_LOCALES.includes(locale) ? 'iglide-ibh' : 'iglidur-ibh'}/${
          shape.shapePath
        }${searchParams}`}
        data-testid={`navigation-link-${shape.shapeKey}`}
      >
        <div
          className={classNames(
            'flex flex-col items-center justify-center w-full h-[75px] rounded-xl border-2 shadow-sm transition-all duration-200 hover:bg-[#FDF2E5]',
            {
              'border-orange-400 bg-[#FDF2E5]': isSelected,
              'border-gray-200 bg-white': !isSelected,
            }
          )}
        >
          {clientReady && (
            <img
              src={`/_${APP_NAME}/images/ibh/shapes/shape_${shape.shapeKey}.png`}
              alt={shape.shapePath.replace(/-/g, ' ')}
              className="max-h-[75px] object-contain"
            />
          )}
        </div>
        <p className="text-xs text-center p-2">
          {t(`SHAPES.${shape.shapeKey}.SHAPE_MENU`, { ns: 'bearing-hub/bearingHub' })}
        </p>
      </Link>
    </div>
  );
};
